import { render, staticRenderFns } from "./MerchantCampaigns.vue?vue&type=template&id=e8b81efc&scoped=true"
import script from "./MerchantCampaigns.vue?vue&type=script&lang=js"
export * from "./MerchantCampaigns.vue?vue&type=script&lang=js"
import style0 from "./MerchantCampaigns.vue?vue&type=style&index=0&id=e8b81efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b81efc",
  null
  
)

export default component.exports